<template>
  <!-- 顶部导航栏 -->
  <div class="top">
    <div class="nav">
      <ul class="username">
        <li v-if="isLogin()"
            style="display: flex;">
          <span style="margin-right:5px;">您好，{{name}}</span>
          <router-link to="/ssm/messageCenter">
          <span
                style="cursor:pointer;margin-left: 10px;">消息
            <el-badge :value="Number(messagenum)"
                      :max="99"
                      type="danger"></el-badge>
          </span>
          </router-link>
        </li>
      </ul>
      <ul>
        <li>
          <a href="javascript:void(0)"
             @click="goMarket">鞋库网</a>
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="goUserIndex">买家工作台</a>
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="goShoppingCart">进货单
            <el-badge :value="Number(cartnum)"
                      :max="99"
                      type="danger"></el-badge>
          </a>
        </li>
        <li>
          <el-dropdown class="help">
            <a href="javascript:void(0)">
              收藏夹<i class="el-icon-arrow-down el-icon--right"></i>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a href="javascript:void(0)"
                   @click="goCollectionGoods">收藏商品</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a href="javascript:void(0)"
                   @click="goCollectionShop">收藏店铺</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="goAdmin">卖家工作台</a>
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="goService">服务市场</a>
        </li>
        <li>
          <el-dropdown class="help">
            <a href="javascript:void(0)">
              联系客服<i class="el-icon-arrow-down el-icon--right"></i>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in serviceList"
                                :key="index">
                <div style="display: flex;align-items: center;" v-html="item.name">
                 <a style="padding: 0;"
                     :href="'http://wpa.qq.com/msgrd?v=3&uin=' + item.value + '&site=qq&menu=yes'"
                     target="_blank">
                  </a>
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="servicePhone">
                热线：<a style="padding: 0;"
                   :href="'tel:' + servicePhone">{{servicePhone}}</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="goHelp">帮助中心</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { configData } from '@/api/login'
import { getToken } from '@/utils/auth'
import { getNavData } from '@/api/home'

export default {
  name: 'TopSmallNav',
  data () {
    return {
      messagenum: 0,
      cartnum: 0,
      serviceList: [],
      servicePhone: null,
      marketDomain: process.env.MARKET_DOMAIN,
      marketUserDomain: process.env.MARKET_USER_DOMAIN,
      token: null
    }
  },
  mounted () {
    this.token = this.$store.getters.token
    this.init()
  },
  methods: {
    init () {
      configData({ key: 'P_serviceQQ', tips: '客服qq' }).then(res => {
        let value = res.data.name
        if (value) {
          value = value.split(/,|，/g)
          this.serviceList = value.map(item => {
            let arr = item.split('|')
            return { name: arr[0], value: arr[1] }
          })
        }
      })
      configData({ key: 'P_servicePhone', tips: '客服电话' }).then(res => {
        this.servicePhone = res.data.name
      })
      if (this.isLogin()) {
        getNavData().then(res => {
          const data = res.data
          if (data) {
            this.messagenum = data.messageQuantity
            this.cartnum = data.cartQuantity
          }
        })
      }
    },
    // 是否登录
    isLogin () {
      return getToken() ? true : false
    },
    // 退出账号
    signOut () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    goMessageCenter () {
      // 前往消息中心
      //alert(1);
      this.$router.push('/messCenter')
      //this.openMarketWindow('/ssm/messageCenter')
    },
    openMarketWindow (url) {
      // 打开商城窗口
      window.open(this.marketDomain + url , '_blank')
    },
    openMarketUserWindow (url) {
      // 打开商城窗口
      window.open(this.marketUserDomain + url + '?t=' + getToken(), '_blank')
    },
    goMarket () {
      // 鞋库网
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain, '_blank')
      } else {
        this.openMarketWindow('')
      }
    },
    goUserIndex () {
      // 前往买家工作台
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain , '_blank')
      } else {
        this.openMarketUserWindow('/user/userIndex')
      }
    },
    goShoppingCart () {
      // 前往进货单
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain , '_blank')
      } else {
        this.openMarketUserWindow('/user/userIndex')
      }
    },
    goCollectionGoods () {
      // 前往收藏商品
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain, '_blank')
      } else {
        this.openMarketUserWindow('/user/menuLayout/collectGoods')
      }
    },
    goCollectionShop () {
      // 前往收藏店铺
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain, '_blank')
      } else {
        this.openMarketUserWindow('/user/menuLayout/collectShops')
      }
    },
    goAdmin () {
      // 前往卖家工作台
      this.$router.push('/home')
    },
    goHelp () {
      // 前往帮助中心
      window.open(this.marketDomain+"/help", '_blank')
    },
    goService () {
      // 前往服务中心
      if (this.token == null || this.token == '') {
        window.open(this.marketDomain, '_blank')
      } else {
        this.openMarketWindow('/serviceMarket/index')
      }
    },
    goHelpCenter () {
      // 前往帮助中心
      this.openMarketWindow('/help')
    }
  },
  computed: {
    ...mapGetters(['name', 'avatar'])
  }
}
</script>

<style lang="scss" scoped>
.top {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  width: 100%;
  background-color: #f5f5f5;
}

.nav {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 34px;
}

.nav ul {
  list-style: none;
  height: 34px;
  margin: 0;
}

.nav li {
  float: left;
}

.nav a,
.nav p {
  text-decoration: none;
  color: #666666;
  padding: 0 10px;
  cursor: pointer;
}

.username a {
  border-left: none;
}

.nav a:hover,
.nav span:hover {
  color: #ef6c00;
}

.username {
  color: #666666;
}
</style>
<style>
.nav ul li .el-badge {
  line-height: 13px;
  transform: scale(0.84, 0.84);
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TopSmallNav.vue